import { Box } from '@mui/material';
import Header from './Header';
import Footer from './Footer';
import BookingForm from './BookingForm';
import WhyChooseUs from './WhyChooseUs';
import AdminHome from './pages/AdminHome';
import Testimony from './Testimony';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Pricing from './Pricing';
import AboutUs from './AboutUs';
import ContactUs from './ContactUs';
import Services from './Services';
import Chatbot from './Chatbot';
import TermsAndConditions from './TermsAndConditions';
import PrivacyPolicy from './PrivacyPolicy';
import Login from './pages/Login';
import Billing from './pages/Billing';

export default function MelbourneClean() {

  return (
    <Router>
      <Box sx={{ fontFamily: 'DM Sans, sans-serif', color: '#0099CC' }}>
        <Header />
        <Routes>
          <Route
            path="/"
            element={
              <div>
                <BookingForm />
                <Testimony />
                <WhyChooseUs />
              </div>
            }
          />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/termsandconditions" element={<TermsAndConditions />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />

          <Route path="/admin" element={<AdminHome />} />
          <Route path="/admin/home" element={<AdminHome />} />
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin/billing" element={<Billing />} />
        </Routes>
        <Chatbot />
        <Footer />
      </Box>
    </Router>
  );
}
